import React, { Component } from "react";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import {
  openEventGuideModal,
  loadEditeventguidesData,
  updateEventGuideFiles,
  deleteEvent,
} from "ActionsEventguide";
import { showError, showSuccess } from "ReduxErrorBar";
import { BASE_IMAGES_URL } from "Constants";
import LocaleStrings from "Languages";
import { Col, Container, Row } from "react-bootstrap";

class EventGuideItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  // Delete Event Guide With Id
  deleteEnevtguideCallback = (param1) => {
    var id = param1;

    confirmAlert({
      title: LocaleStrings.content_chooser_delete_eventguide_title,
      message: LocaleStrings.content_chooser_delete_eventguide_message,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            // //this.props.session
            this.props.deleteEvent(
              this.props.session,
              id,
              (CallBackResponse) => {
                if (CallBackResponse.success) {
                  // Show success message
                  this.props.showSuccess(
                    `${LocaleStrings.content_eventguide_form_success}`
                  );
                  this.props.finishOperationsCallback();
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  // Modal Call function
  editEventGuideCallback(obj) {
    var eventguides = this.props.eventguide;
    var fileName1 = "";
    var fileName2 = "";
    var fileName3 = "";
    var fileName4 = "";
    var fileName5 = "";
    var fileName6 = "";
    var fileName7 = "";
    var fileName8 = "";
    var fileName9 = "";
    var fileName10 = "";

    if (eventguides.file1) {
      var f1 = eventguides.file1.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName1 = f2 + "." + ext;
    }
    if (eventguides.file2) {
      var f1 = eventguides.file2.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName2 = f2 + "." + ext;
    }
    if (eventguides.file3) {
      var f1 = eventguides.file3.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName3 = f2 + "." + ext;
    }
    if (eventguides.file4) {
      var f1 = eventguides.file4.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName4 = f2 + "." + ext;
    }
    if (eventguides.file5) {
      var f1 = eventguides.file5.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName5 = f2 + "." + ext;
    }
    if (eventguides.file6) {
      var f1 = eventguides.file6.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName6 = f2 + "." + ext;
    }
    if (eventguides.file7) {
      var f1 = eventguides.file7.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName7 = f2 + "." + ext;
    }
    if (eventguides.file8) {
      var f1 = eventguides.file8.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName8 = f2 + "." + ext;
    }
    if (eventguides.file9) {
      var f1 = eventguides.file9.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName9 = f2 + "." + ext;
    }
    if (eventguides.file10) {
      var f1 = eventguides.file10.split("/").pop();
      var f2 = f1.substr(0, f1.lastIndexOf("_"));
      var ext = f1.split(".").pop();

      fileName10 = f2 + "." + ext;
    }

    var files = [
      {
        position: "file1",
        file: eventguides.file1 ? eventguides.file1 : "",
        filename: fileName1,
      },
      {
        position: "file2",
        file: eventguides.file2 ? eventguides.file2 : "",
        filename: fileName2,
      },
      {
        position: "file3",
        file: eventguides.file3 ? eventguides.file3 : "",
        filename: fileName3,
      },
      {
        position: "file4",
        file: eventguides.file4 ? eventguides.file4 : "",
        filename: fileName4,
      },
      {
        position: "file5",
        file: eventguides.file5 ? eventguides.file5 : "",
        filename: fileName5,
      },
      {
        position: "file6",
        file: eventguides.file6 ? eventguides.file6 : "",
        filename: fileName6,
      },
      {
        position: "file7",
        file: eventguides.file7 ? eventguides.file7 : "",
        filename: fileName7,
      },
      {
        position: "file8",
        file: eventguides.file8 ? eventguides.file8 : "",
        filename: fileName8,
      },
      {
        position: "file9",
        file: eventguides.file9 ? eventguides.file9 : "",
        filename: fileName9,
      },
      {
        position: "file10",
        file: eventguides.file10 ? eventguides.file10 : "",
        filename: fileName10,
      },
    ];

    this.props.loadEditeventguidesData(eventguides);
    this.props.openEventGuideModal({
      showModal: true,
      idFieldName: eventguides.id,
      idFieldLable: eventguides.id,
    });
    this.props.updateEventGuideFiles(files);
  }

  render() {
    let { eventguide, mydata } = this.props;
    var type = "";
    if (this.props.eventguide.type == "weblink") {
      type = "Page";
    } else if (this.props.eventguide.type == "pdf") {
      type = "Docs";
    } else {
      type = "Text";
    }
    var icon = "";
    //eventguide icon
    var imgURL = "../../style/images/placeholder_600x400.svg";
    if (
      eventguide.image !== "" &&
      eventguide.image !== undefined &&
      eventguide.image != null
    ) {
      if (
        eventguide.image.endsWith(".jpg") ||
        eventguide.image.endsWith(".png")
      ) {
        imgURL = `${BASE_IMAGES_URL}/${eventguide.image}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      } else {
        var parseIcon = JSON.parse(eventguide.image);
        imgURL = "";
        icon = parseIcon.title;
      }
    }

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${imgURL})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",
      backgroundPosition: "50% 50%",
    };

    return (
      <Container fluid>
        <Row
          style={{
            fontWeight: "normal",
            color: "rgb(63,68,88)",
            borderTop: "1px solid #e6edf3",
            borderBottom: "1px solid #e6edf3",
            padding: "10px 0",
            cursor: "move",
          }}
        >
          <Col>
            <div className="vertical-align-center">
              <div style={style}>
                <i className={icon} style={{ fontSize: "25px" }}></i>
              </div>
              <div className="eventguide-td" style={{ paddingLeft: 30 }}>
                <div className="vcenter ">{mydata}</div>
              </div>
            </div>
          </Col>
          <Col>
            <div
              className="vertical-align-center h-full eventguide-td2"
              style={{ paddingLeft: "20%" }}
            >
              {type}
            </div>
          </Col>
          <Col>
            <div
              className="vertical-align-center h-full eventguide-td3 gap-1"
              style={{ paddingLeft: "20%" }}
            >
              <button
                className="btn btn-custom-table-white"
                onClick={this.editEventGuideCallback.bind(this)}
              >
                {LocaleStrings.button_edit}
              </button>{" "}
              <button
                className="i-custom-table-delete"
                onClick={() =>
                  this.deleteEnevtguideCallback(this.props.eventguide.id)
                }
              >
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openEventGuideModal,
  loadEditeventguidesData,
  updateEventGuideFiles,
  deleteEvent,
})(EventGuideItem);
